import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("email");

const reqEMail = {
	sendEMail: async function (body) {
		return apiServer
			.post("email/v1/recovery", body, {
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log("error", error);

				throw error;
			});
	},
};

export default reqEMail;
